import { resolveImage } from "@/lib/api";

// Bento pattern. Inline grid spans so Tailwind JIT isn't bypassed.
// In a 4-col grid this cycle (8 tiles) tiles 4 cols × 4 rows = 16 cells with zero whitespace.
// In a 2-col grid, the same spans cap at col 2 (full width) and still tile cleanly.
const SPANS = [
  { col: 2, row: 2 }, // big
  { col: 2, row: 1 }, // wide
  { col: 1, row: 1 },
  { col: 1, row: 1 },
  { col: 2, row: 2 }, // big
  { col: 1, row: 1 },
  { col: 1, row: 1 },
  { col: 2, row: 1 }, // wide
];

export default function Gallery({ data }) {
  const images = data?.images || [];
  return (
    <section id="gallery" data-testid="section-gallery" className="section-pad bg-[#FDFBF7]">
      <div className="container-pad">
        <div className="max-w-2xl">
          <div className="kicker">{data.kicker || "Campus Life"}</div>
          <h2 className="heading-main mt-4">{data.title}</h2>
        </div>

        <div className="mt-12 overflow-hidden rounded-3xl shadow-[0_8px_40px_-12px_rgba(15,23,42,0.18)] bg-white">
          <div
            className="grid grid-cols-2 md:grid-cols-4 gap-0 auto-rows-[130px] sm:auto-rows-[160px] md:auto-rows-[180px] lg:auto-rows-[210px]"
            style={{ gridAutoFlow: "dense" }}
            data-testid="gallery-grid"
          >
            {images.map((src, i) => {
              const s = SPANS[i % SPANS.length];
              return (
                <figure
                  key={i}
                  className="relative overflow-hidden group bg-slate-100"
                  style={{ gridColumn: `span ${s.col}`, gridRow: `span ${s.row}` }}
                  data-testid={`gallery-item-${i}`}
                >
                  <img
                    src={resolveImage(src)}
                    alt=""
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transform-gpu group-hover:scale-[1.06] transition duration-[1100ms] ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B1736]/45 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-500" />
                </figure>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
